import { EncryptStorage } from "encrypt-storage";

import Env from "../config/env";

// eslint-disable-next-line import/no-anonymous-default-export
export default new EncryptStorage(Env.APP_KEY);
